import { Checkbox } from '@hub/common/Checkbox/Checkbox';
import { title } from 'process';
import { type CheckboxFilter, FilterType, type Type } from '../../types';
import { FilterRangeInput, type FilterRangeInputProps } from '@hub/common/inputs/FilterRangeInput';
import {
  FilterSelectAutocomplete,
  type FilterSelectAutocompleteProps,
} from '@hub/common/inputs/FilterSelectAutocomplete';
import type { BasicNumberInputProps } from '@hub/common/BasicNumberInput/BasicNumberInput';
import { BasicNumberInput } from '@hub/common/BasicNumberInput/BasicNumberInput';

export interface FilterWrapperProps {
  type: Type;
  props: { key: string } & (
    CheckboxFilter | FilterSelectAutocompleteProps | FilterRangeInputProps | BasicNumberInputProps
  );
}

export const FilterWrapper = ({ type, props }: FilterWrapperProps) => {
  switch (type) {
    case FilterType.CHECKBOX: {
      const { disabled, id, key, label, onChange, value } = props as CheckboxFilter;
      return (
        <Checkbox
          disabled={disabled}
          key={key}
          id={id}
          value={value}
          onChange={newVal => onChange(newVal)}
          label={label}
        />
      );
    }
    case FilterType.RANGE: {
      const { id, max, min, label, unit, values, onChange } = props as FilterRangeInputProps;
      return (
        <FilterRangeInput
          id={id}
          max={max}
          min={min}
          label={label}
          unit={unit}
          values={values}
          onChange={newVal => onChange(newVal)}
        />
      );
    }
    case FilterType.AUTOCOMPLETE: {
      const { id, label, placeholder, options, value, isMulti, filterOptions, styles, isClearable, onChange } =
        props as FilterSelectAutocompleteProps;
      return (
        <FilterSelectAutocomplete
          id={id}
          label={label}
          placeholder={placeholder}
          options={options}
          filterOptions={filterOptions}
          value={value}
          isMulti={isMulti}
          isClearable={isClearable}
          styles={styles}
          hideOptionsModel
          onChange={newVal => onChange(newVal)}
        />
      );
    }
    case FilterType.NUMBER: {
      const { id, placeholder, value, unit, onChange, validator, errorMessage } = props as BasicNumberInputProps;
      return (
        <BasicNumberInput
          id={id}
          unit={unit}
          onChange={newValue => {
            onChange(newValue);
          }}
          placeholder={placeholder}
          value={value}
          title={title}
          validator={validator}
          errorMessage={errorMessage}
        />
      );
    }
  }
};
